import React, { Component } from 'react'

export default class Userinfo extends Component {
    handleLogout = () => {
        const apiUrl = process.env.REACT_APP_API_ENDPOINT;
        const param = JSON.parse(window.localStorage.getItem('param'));
        const eat = param.eat;
        
        const logoutUrl = new URL('/oauth/logout', apiUrl);

        logoutUrl.searchParams.set('eat', eat);

        window.localStorage.clear();
        window.location.replace(logoutUrl.toString());
    }

    render() {
        return (
            <div className="nickname">
                <span>Hi, {decodeURIComponent(this.props.main.user.nickname)} </span>
                <div className="tabCurrent">
                    <span>{this.props.title}</span>
                    <button onClick={() => {
                        this.handleLogout()
                    }} className="btn btn__logout">Logout</button>
                </div>
            </div>
        )
    }
}